import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { SimpleTable } from '~/components';

export default function Detalhe({ data }) {
  const header = useMemo(
    () => [
      { id: 'prde_codigo', label: 'Código' },
      { id: 'prde_nome', label: 'Nome' },
    ],
    []
  );

  if (data && data.veic_placa)
    return (
      <SimpleTable
        cells={header}
        url="veiculo/produto"
        unique={['prde_codigo']}
        onCreate={false}
        onUpdate={false}
        onDelete={false}
        query={{
          wherefield: ['veic_placa'],
          valuewherefield: [data.veic_placa],
          typewherefield: ['EQUALS'],
        }}
      />
    );

  return '';
}

Detalhe.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};
